import React from 'react';
import NodePersonalizado from './NodePersonalizado';

import "./style.scss"

export default function NodeFinalizar({ data, id, type, ...rest }) {
    return <NodePersonalizado key={id} id={id} label={data?.nome} data={data} type={type} handles={0} {...rest} />
}